import React, { useState, useEffect } from "react";
import Pagination from "../../../../Components/Pagination/Pagination";
import SkeletonLoading from "../../../../Components/Skeleton/SkeletonLoading";
import { PatientInfo } from "../../../../Services/Models/Order/OrderModel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type Props = {
  loading: boolean;
  tableData: PatientInfo[];
  rowsPerPage: number;
  dataLength: number;
}

function LoaderSkeleton() {
  let loader: any = [];
  for (let index = 0; index < 10; index++) {
    loader.push(
      <tr className={`hoversuccess`} key={"skeletonLoaderTr_"+ index}>
        <td className="patient-col" key={"skeletonLoadertd1_"+ index}>{<SkeletonLoading />}</td>
        <td className="condition-col text-center" key={"skeletonLoadertd2_"+ index}>{<SkeletonLoading />}</td>
        <td className="qty-col text-center" key={"skeletonLoadertd3_"+ index}>{<SkeletonLoading />}</td>
        <td className="patient-total text-end pe-4" key={"skeletonLoadertd4_"+ index}></td>
      </tr>
    );
  }
  return (
    <>
      {loader}
    </>
  )
}

export default function PatientLeadsOrderListTable({tableData, rowsPerPage, loading, dataLength, ...args}: Props) {
  const [isPagination, setIsPagination] = useState<boolean>(false);
  const [displayRange, setDisplayRange] = useState<string>();
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    let totalPages = Math.ceil(tableData.length / rowsPerPage);
    if(dataLength === 0 || tableData?.length <= rowsPerPage){
        setIsPagination(false)
    }else{
        setIsPagination(true)
    }
    // tableData?.length <= rowsPerPage && setDisplayRange(`1 - ${tableData?.length}`);
    // tableData?.length > rowsPerPage && setDisplayRange(`${(page - 1) * rowsPerPage + 1} - ${page * rowsPerPage}`);
    tableData?.length <= rowsPerPage && setDisplayRange(`${tableData?.length}`);
    tableData?.length > rowsPerPage && setDisplayRange(`${page === totalPages ? tableData.length : (page * rowsPerPage)}`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData, page]);

  return (
    <>
      <div className={`order-table-wrap ${!loading ? "with-checkbox" : ""} mb-3`} key={"orderTableWrap"}>
        <table className="table" data-testid="patientListComponent" key={"patientOrderListTable"}>
          <thead key={"patientOrderListThead"}>
            <tr key={"tr1"}>
              <th scope="col" style={{ color:"#66CFC8"}} className="patient-col mt-1" key={"th1"}>
                Patient
              </th>
              <th scope="col" style={{ color: "#66CFC8" }} className="condition-col" key={"th2"}>
                Parent Name
              </th>
              <th scope="col" style={{ color: "#66CFC8" }} className="qty-col text-center" key={"th3"}>
                Qty.
              </th>
              <th scope="col" className="patient-total text-end pe-4" key={"th4"}>
                {displayRange} of {tableData?.length} {tableData?.length > 1 ? "patients" : "patient"}
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData && !loading ? tableData && tableData?.length > 0 ? (
              tableData?.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((el: any, index: number) => {
                  return (
                    <>
                        <tr key={index}>
                          <td className={"checked"} key={`${index}_1`}>
                            {(el?.firstname).length > 20 ? (
                              <>
                                <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{el?.firstname}</Tooltip>)} placement="bottom">
                                  <label style={{ width: "215px", fontSize: "18px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: "10px" }}>
                                    {el?.firstname}
                                  </label>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <>
                                <label style={{ fontSize: "18px", paddingRight: "10px" }}>
                                  {el?.firstname}
                                </label>
                              </>
                            )}
                          </td>
                          <td className={`checked`} key={`${index}_2`}>
                            {(el?.ecFirstName + " " + el?.ecLastName).length > 20 ? (
                              <>
                                <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{el?.ecFirstName + " " + el?.ecLastName}</Tooltip>)} placement="bottom">
                                  <label style={{ width: "215px", fontSize: "16px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {el?.ecFirstName + " " + el?.ecLastName}
                                  </label>
                                </OverlayTrigger>
                              </>
                            ) : (
                              <>
                                <label style={{fontSize: "16px"}}>
                                  {el?.ecFirstName + " " + el?.ecLastName}
                                </label>
                              </>
                            )}
                          </td>
                          <td className={`text-center checked`} key={`${index}_3`}>1</td>
                          <td className={`text-end checked`} key={`${index}_4`}></td>
                        </tr>
                    </>
                  );
                })
            ) : (
              <tr className="no-bg">
                <td className="text-error text-center">No Patients Matched</td>
              </tr>
            ) : (
              <>
                <LoaderSkeleton />
              </>
            )}
          </tbody>
        </table>
      </div>
      {( tableData && !loading && isPagination) ? (
        <Pagination
          dataLength={dataLength}
          page_number={page}
          page_size={rowsPerPage}
          setpage_number={setPage}
        /> 
      ) : ""}
    </>
  );
}
